import React, { useState } from 'react';
import styles from '../styles/SignInModal.module.css';
import { ConnectButton } from './ConnectButton';
import { useAuth } from '../../context/AuthContext';

const SignInModal = ({ open, onClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { loginCardUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch('/api/auth/sign-in', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setError(data.error || 'Sign-in failed.');
      } else {
        // Update auth context here
        if (data.user) {
          loginCardUser(data.user.email, data.user._id, data.user.referralCode);
        }
        onClose();
      }
    } catch (err) {
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button onClick={onClose} className={styles.closeButton}>&times;</button>
        <h3 className={styles.title}>Sign In</h3>
        <p className={styles.description}>Sign in with your email and password or connect your wallet.</p>
        <form className={styles.form} onSubmit={handleSubmit}>
          <input
            className={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
            disabled={loading}
          />
          <input
            className={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="current-password"
            disabled={loading}
          />
          {error && <div className={styles.error}>{error}</div>}
          <button className={styles.emailButton} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <div className={styles.separator}><span>or</span></div>
        <div className={styles.walletButtonContainer}>
          <ConnectButton />
        </div>
      </div>
    </div>
  );
};

export default SignInModal; 